import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';

const users = [
    {
        id: 1,
        nom: 'Mechichi',
        prenom: 'Chokri',
        tel: '+216895623',
        email: 'choko@gmail.com',
        genre: 'Masculin',
        adresse: 'Ariana , Tunisie',
        zip: '2056',
        img: '',
        isActive: true,
        role : 'root'
    },
    {
        id: 1,
        nom: 'Isor',
        prenom: 'Lynie',
        tel: '+33006231458',
        email: 'lynie@isor.com',
        genre: 'Masculin',
        adresse: 'Boulevard Barbès, 75018 Paris',
        zip: '75018',
        img: '',
        isActive: true ,
        role : 'admin'
    },
    {
        id: 1,
        nom: 'Habib',
        prenom: 'Laurent',
        tel: '+330014789632',
        email: 'laurent.habib@gmail.com',
        genre: 'Masculin',
        adresse: '',
        zip: '75000',
        img: '',
        isActive: true ,
        role : 'directeur'
    },
    {
        id: 1,
        nom: 'Salas',
        prenom: 'claudia',
        tel: '+330023153524',
        email: 'claudia@gmail.com',
        genre: 'Féminin',
        adresse: '',
        zip: '75000',
        img: '',
        isActive: true ,
        role : 'vendeur'
    },
]

const clients = [
    {
        id: 1,
        nom: 'Raymond',
        prenom: 'Gervais',
        tel: '+330511949426',
        email: 'Raymond@gmail.com',
        genre: 'Masculin',
        adresse: '55, rue Pierre De Coubertin 31400 TOULOUSE',
        zip: '31400',
        img: '',
        status: 'client',
        note: 3,
        origin: 'boutique',
        nbr_achat: 13,
        total_achat: '36K',
        ddn: '30/01/1978',
        ddm: '30/01/2001',
        isVip: false,
        tags: []
    },

    {
        id: 2,
        nom: 'Christian',
        prenom: 'Norbert',
        tel: '+330322730319',
        email: 'Christian@gmail.com',
        genre: 'Masculin',
        adresse: '36, boulevard Aristide Briand',
        zip: '71200',
        img: '',
        status: 'client',
        note: 3,
        origin: 'boutique',
        nbr_achat: 13,
        total_achat: '21K',
        ddn: '15/10/1985',
        ddm: '30/01/2009',
        isVip: false,
        tags: []
    },

    {
        id: 3,
        nom: 'Soren',
        prenom: 'Ruest',
        tel: '+330373631636',
        email: 'Christian@gmail.com',
        genre: 'Masculin',
        adresse: '33, rue du Président Roosevelt',
        zip: '67300',
        img: '',
        status: 'prospect',
        note: 3,
        origin: 'boutique',
        nbr_achat: 13,
        total_achat: '21K',
        ddn: '08/09/1996',
        ddm: '30/01/2020',
        isVip: true,
        tags: []
    },

    {
        id: 4,
        nom: 'Aubert',
        prenom: 'Moquin',
        tel: '+330373631636',
        email: 'AubertMoquin@armyspy.com',
        genre: 'Masculin',
        adresse: '8, place Maurice-Charretier',
        zip: '94220',
        img: '',
        status: 'client',
        note: 4,
        origin: 'boutique',
        nbr_achat: 13,
        total_achat: '21K',
        ddn: '08/09/1996',
        ddm: '30/01/2020',
        isVip: true,
        tags: []
    },

    {
        id: 5,
        nom: 'Turner',
        prenom: 'Saucier',
        tel: '+330373631636',
        email: 'TurnerSaucier@teleworm.us',
        genre: 'Masculin',
        adresse: '35, rue Charles Corbeau',
        zip: '45400',
        img: '',
        status: 'prospect',
        note: 4,
        origin: 'boutique',
        nbr_achat: 13,
        total_achat: '21K',
        ddn: '08/09/1996',
        ddm: '30/01/2020',
        isVip: true,
        tags: []
    },
]

const fournisseurs = [
    {
        id: 1,
        nom: '',
        tel: '',
        email: '',
        adresse: '',
        zip: '',
        img: '',
        isActive: true,
        kbis: '',
        fiablilite_reparateur: '',
        delais_general: 3,
        description: '',
        commentaire: '',
        isUe: true,
        isPoisson: false,

    },
]

const magasins = [
    {
        id: 1,
        code: '',
        adresse: '',
        zip: ''

    }
]

const grp_magasins = [
    {
        id: 1,
        code: '',
        nom: '',
        adresse_facture: '',
        adresse_siege: '',
        siren: '',
        forme_juridique: '',
        capital: 0,
        num_rcs: '',
        ville_greffe: '',
        cgv: '#',
        garantie: '#',
        num_tva: '',

    }
]

const initialState = {
    loading: false,
    erro: '',
    lst_user: [...users],
    lst_client: [...clients],
    lst_fournisseur: [...fournisseurs],
    lst_magasin: [...magasins],
    lst_grp_magasin: [...grp_magasins],
};

const FakeApiSlice = createSlice({
    name: "API",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        addUnit: (state, action) => {
            if (action?.payload?.target) {
                if (Array.isArray(state[action?.payload?.target])) {

                    state[action?.payload?.target] = [...state[action?.payload?.target] , {...action?.payload?.data , id : state[action?.payload?.target].length}]
                }
            }
        },
        updateUnit: (state, action) => {
            if (action?.payload?.target) {
                if (Array.isArray(state[action?.payload?.target])) {

                    state[action?.payload?.target] = state[action?.payload?.target].map(el => el?.id == action?.payload?.data?.id ? action?.payload?.data : el)
                }
            }
        },
        deleteUnit: (state, action) => {
            if (action?.payload?.target) {
                if (Array.isArray(state[action?.payload?.target])) {

                    state[action?.payload?.target] = state[action?.payload?.target].filter(el => el?.id != action?.payload?.data)
                }
            }
        },


    },
    extraReducers: {}
})

const { reducer } = FakeApiSlice;
export const { clear, setLoading , addUnit , updateUnit , deleteUnit } = FakeApiSlice.actions;
export default reducer;